import { supabase } from './supabase';
import { toCamel } from '../utils/helpers';

export async function schedulePtSession({ assignmentId, scheduledAt, notes }) {
  const { data, error } = await supabase.rpc('schedule_pt_session', {
    p_assignment_id: assignmentId,
    p_scheduled_at: scheduledAt,
    p_notes: notes || null,
  });
  return { id: data, error };
}

export async function cancelPtSession(sessionId) {
  const { error } = await supabase.rpc('cancel_pt_session', { p_session_id: sessionId });
  return { error };
}

export async function completePtSession(sessionId, content, memo) {
  const { error } = await supabase.rpc('complete_pt_session', {
    p_session_id: sessionId,
    p_content: content || null,
    p_memo: memo || null,
  });
  return { error };
}

export async function getPtSessionsForGym(gymId) {
  const { data, error } = await supabase.rpc('get_pt_sessions_for_gym', { p_gym_id: gymId });
  if (error) { console.error('[getPtSessionsForGym]', error); return []; }
  return (data || []).map(toCamel);
}

export async function getPtSessionsForTrainer() {
  const { data, error } = await supabase.rpc('get_pt_sessions_for_trainer');
  if (error) { console.error('[getPtSessionsForTrainer]', error); return []; }
  return (data || []).map(toCamel);
}

export async function getPtSessionsForMember() {
  const { data, error } = await supabase.rpc('get_pt_sessions_for_member');
  if (error) { console.error('[getPtSessionsForMember]', error); return []; }
  return (data || []).map(toCamel);
}
